export default __webpack_public_path__ + "static/media/Apercu-LightItalic.50ca6ab3.otf";